// Mapbox/OSM implementation of the map adapter interface.
export const createMapboxAdapter = (map) => {
    // Engine-neutral { north, south, east, west } -> Mapbox [[w, s], [e, n]].
    const fitBoundingBox = ({ north, south, east, west }, options) => new Promise((resolve) => {
        map.fitBounds([[west, south], [east, north]], { padding: 80, ...options });
        map.once('moveend', resolve);
    });

    return { fitBoundingBox };
};
